// 2021-1-1 12_30_59

export default function formatDateTimeShort(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()} ${date.getUTCHours()}_${date.getUTCMinutes()}_${date.getUTCSeconds()}`;
}
